import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";

import axios from "axios";
import { Form } from "react-bootstrap";

import logo from "../../../image/authentication/authentication-logo.png";
import loginType from "../../../redux/actions/login/loginType";
import { checkUserExistApi, registerRequestCodeApi } from "../../../utility/api/apiList";

import { showDangerAlert } from "../../../redux/actions/alert/alertActions";

import { convertNumbersToEn } from "../../../libs/convertNumbers";


import ButtonComponent from "../button";

import {
  StyledForm,
  StyledAuthenticationSection,
  StyledContainer,
  StyledAuthenticationLogoWrapper,
  StyledAuthenticationLogo,
  StyledFormGroup,
} from "./loginStyled";

export default function GetStatusUser() {
  const [inputValue, setInputValue] = useState("");
  const dispatch = useDispatch();

  // error
  const [phoneError, setPhoneError] = useState("");

  const inputContainer = useRef(null);
  useEffect(() => {
    inputContainer.current.focus();
  });

  const formValidation = (e) => {
    e.preventDefault();
    // Convert Farsi numbers to English
    const phoneNumber = convertNumbersToEn(inputValue);
    if (!phoneNumber) {
      setPhoneError("شماره همراه نباید خالی باشد.");
    } else if (phoneNumber.length !== 11) {
      setPhoneError(
        "شماره همراه باید 11 رقم باشد. مانند این وارد کنید: 09123456789"
      );
    } else if (phoneNumber && phoneNumber.length === 11) getStatus(phoneNumber);
  };

  const getStatus = (phoneNumber) => {
    axios
      .get(`${checkUserExistApi}${phoneNumber}/`)
      .then((response) => {
        const isRegistered = JSON.parse(response.data.isRegistered);
        if (isRegistered) {
          dispatch({
            type: loginType.CHANGE_ACTIVE_STEP,
            payload: 1,
            username: phoneNumber,
          });
        } else {
          const phone = {
            phone: phoneNumber,
          };
          axios
            .post(registerRequestCodeApi, phone)
            .then(() => {
              dispatch({
                type: loginType.START_REGISTER,
                payload: 3,
                username: phoneNumber,
              });
            })
            .catch((error) => {
              dispatch(showDangerAlert(error.response?.data?.results));
            });
        }
      })
      .catch(() => {
        setPhoneError("موبایل نامعتبر است. مانند این وارد کنید : 09102260226");
      });
  };

  //  FIXME: Use FormData() or form hook to prevent page render on every onChange input event
  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <StyledAuthenticationSection>
      <StyledContainer $maxWidth="510px">
        <StyledForm noValidate className="px-sm-5" onSubmit={formValidation}>
          <StyledAuthenticationLogoWrapper className="mx-auto">
            <StyledAuthenticationLogo src={logo} alt="azeto-logo" />
            <h1 className="h6 text-center">ورود/ ثبت‌نام</h1>
          </StyledAuthenticationLogoWrapper>
          <StyledFormGroup>
            <Form.Label htmlFor="phone-number">
              لطفا شماره همراه خود را وارد کنید.
            </Form.Label>
            <Form.Control
              type="number"
              pattern="\d*"
              className="mt-2"
              autoComplete="true"
              name="username"
              id="phone-number"
              placeholder="09123456789"
              ref={inputContainer}
              onChange={handleChange}
              value={inputValue}
              maxLength="11"
            />
            <Form.Text className={phoneError ? "text-danger" : "text-muted"}>
              {phoneError ? phoneError : "لطفا شماره را با کد 0 وارد کنید."}
            </Form.Text>
          </StyledFormGroup>
          <ButtonComponent
            type="submit"
            className="px-5 mt-5 w-100"
            disabled={!inputValue}
          >
            تایید
          </ButtonComponent>
        </StyledForm>
      </StyledContainer>
    </StyledAuthenticationSection>
  );
}
